"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.schemaMensal = exports.yupMensal = exports.schemaBaixaMensal = exports.yupBaixaMensal = exports.schemaAlteraMensal = exports.yupAlteraMensal = exports.schemaNovaMensal = exports.yupNovaMensal = void 0;
const date_fns_1 = require("date-fns");
const yup = __importStar(require("yup"));
const enums_1 = require("../enums");
const utils_1 = require("../utils");
exports.yupNovaMensal = yup.object({
    idAluno: yup.number().positive().required().integer().label('Aluno'),
    idCurso: yup.number().positive().required().integer().label('Curso'),
    idProduto: yup.number().required().integer().label('Tipo'),
    idCategoriaAluno: yup.number().positive().required().integer().label('Categoria'),
    idEmpresa: yup.number().positive().required().integer().label('Empresa'),
    idTipoDesconto1: yup.number().positive().integer().nullable().default(null).label('Tipo'),
    idTipoDesconto2: yup
        .number()
        .positive()
        .integer()
        .nullable()
        .default(null)
        .test('match', 'Desconto 1 deve ser diferente do Desconto 2', (v, { parent: { idTipoDesconto1 } }) => v === null || idTipoDesconto1 === null || v !== idTipoDesconto1)
        .label('Tipo'),
    dataVencimento: (0, utils_1.sge2Date)().required().default(new Date().toISOString()).label('1º Venc'),
    anoLetivo: yup.string().required().default(new Date().getFullYear().toString()).label('Ano letivo'),
    valorCurso: yup.number().positive().required().default(0).label('Valor Integral'),
    valor: yup.number().positive().required().default(0).label('Valor Parcela'),
    parcelas: yup.number().required().positive().integer().default(1).label('Nº Parcelas'),
    descontoBoleto: yup.number().integer().min(0).max(100).nullable().default(0).label('Desconto'),
    nParCartao: yup
        .number()
        .integer()
        .min(0)
        .max(12)
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .default(null)
        .label('Nº Parcelas'),
    desconto1: yup.number().nullable().default(null).label('Desc'),
    desconto2: yup.number().nullable().default(null).label('Desc'),
    nPerdeDesc1: yup.bool().nullable().default(false).label('Não Perde desconto'),
    nPerdeDesc2: yup.bool().nullable().default(false).label('Não Perde desconto'),
    desconto: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(0)
        .test('match', 'Desconto 1 e Desconto 2 não pode ultrapassar 100', (_, { parent: { desconto2, desconto1 } }) => desconto2 || desconto1 ? desconto2 + desconto1 < 100 : true)
        .label('Total Desconto'),
    nCobrador: yup
        .mixed()
        .oneOf(Object.values(enums_1.ENumeroCobradora))
        .nullable()
        .default(enums_1.ENumeroCobradora.Escola)
        .label('Local de Cobrança'),
});
exports.schemaNovaMensal = exports.yupNovaMensal.shape({});
exports.yupAlteraMensal = yup.object({
    idCurso: yup.number().integer().positive().required().label('Curso'),
    idProduto: yup.number().integer().nullable().label('Tipo'),
    idCategoriaAluno: yup.number().positive().integer().nullable().default(null).label('Categoria'),
    idEmpresa: yup.number().integer().positive().required().label('Empresa'),
    idTipoDesconto1: yup
        .number()
        .positive()
        .integer()
        .nullable()
        .default(null)
        .test('match', 'Desconto 1 deve ser diferente do Desconto 2', (v, { parent: { idTipoDesconto2 } }) => v === null || idTipoDesconto2 === null || v !== idTipoDesconto2)
        .test('match', 'Ao escolher o tipo de desconto deve-se informar o valor', (idTipoDesconto1, schema) => {
        if (idTipoDesconto1 == null && (schema.parent.desconto1 || 0) > 0)
            return false;
        if (idTipoDesconto1 != null && (schema.parent.desconto1 || 0) == 0)
            return false;
        return true;
    })
        .label('Tipo'),
    idTipoDesconto2: yup
        .number()
        .positive()
        .integer()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .default(null)
        .test('match', 'Desconto 1 deve ser diferente do Desconto 2', (v, { parent: { idTipoDesconto1 } }) => v === null || idTipoDesconto1 === null || v !== idTipoDesconto1)
        .test('match', 'Ao escolher o tipo de desconto deve-se informar o valor', (idTipoDesconto2, schema) => {
        if (idTipoDesconto2 == null && (schema.parent.desconto2 || 0) > 0)
            return false;
        if (idTipoDesconto2 != null && (schema.parent.desconto2 || 0) == 0)
            return false;
        return true;
    })
        .label('Tipo'),
    idAluno: yup.number().integer().positive().required().label('Aluno'),
    parcela: yup.string().length(2).required().default('01').label('Parcela'),
    desconto: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(0)
        .test('match', 'Desconto 1 e Desconto 2 não pode ultrapassar 100', (_, { parent: { desconto2, desconto1 } }) => desconto2 || desconto1 ? desconto2 + desconto1 < 100 : true)
        .label('Total Desconto'),
    data: (0, utils_1.sge2Date)().required().default(new Date().toISOString()).label('Data de cadastro'),
    dataVencimento: (0, utils_1.sge2Date)().required().default(new Date().toISOString()).label('Data Venc.'),
    valorCurso: yup.number().min(0).required().default(0).label('Valor Curso'),
    tipo: yup.string().required().max(15).default('MENSALIDADE').label('Tipo Parcela'),
    valor: yup.number().positive().min(0).required().default(0).label('Valor Parcela'),
    bloqueto: yup.string().max(12).nullable().default('').label('Bloqueto'),
    observacao: yup.string().max(200).nullable().default('').label('Observação'),
    debitoAuto: yup.bool().nullable().default(false).label('Débito automático'),
    cobranca: yup.bool().nullable().default(false).label('Imprimir Cobrança'),
    remessa: yup.bool().nullable().default(false).label('Remessa'),
    naoEnviar: yup.bool().nullable().default(false).label('Enviar ao banco'),
    cobradora: yup.bool().nullable().default(false).label('Cobradora'),
    prorrogada: yup.bool().nullable().default(false).label('Parcela prorrogada'),
    autMulta: yup.bool().nullable().default(false).label('Sem Multa e Juros'),
    nCobrador: yup
        .mixed()
        .oneOf(Object.values(enums_1.ENumeroCobradora))
        .nullable()
        .default(enums_1.ENumeroCobradora.Escola)
        .label('Local de Cobrança'),
    agrupamento: yup
        .mixed()
        .oneOf((0, enums_1.enumValues)(enums_1.EMensalAgrupamento))
        .required()
        .default(enums_1.EMensalAgrupamento['Padrão'])
        .label('Agrupamento'),
    cartorio: yup.bool().nullable().default(false).label('Está no cartório'),
    desconto1: yup
        .number()
        .min(0)
        .max(100)
        .nullable()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .test('match', 'Ao informar o valor do desconto deve-se escolher o tipo', (desconto1, schema) => {
        if (schema.parent.idTipoDesconto1 == null && (desconto1 || 0) > 0)
            return false;
        if (schema.parent.idTipoDesconto1 != null && (desconto1 || 0) == 0)
            return false;
        return true;
    })
        .label('Desconto'),
    desconto2: yup
        .number()
        .min(0)
        .max(100)
        .nullable()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .test('match', 'Ao informar o valor do desconto deve-se escolher o tipo', (desconto2, schema) => {
        if (schema.parent.idTipoDesconto2 == null && (desconto2 || 0) > 0)
            return false;
        if (schema.parent.idTipoDesconto2 != null && (desconto2 || 0) == 0)
            return false;
        return true;
    })
        .label('Desconto'),
    nPerdeDesc1: yup.bool().nullable().default(false).label('Não Perde desconto'),
    nPerdeDesc2: yup.bool().nullable().default(false).label('Não Perde desconto'),
    permuta: yup.bool().nullable().default(false).label('Permuta'),
    descontoBoleto: yup.number().integer().min(0).max(100).nullable().default(0).label('Desconto'),
    nParCartao: yup
        .number()
        .integer()
        .min(0)
        .max(12)
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .default(null)
        .label('Nº Parcelas'),
});
exports.schemaAlteraMensal = exports.yupAlteraMensal.shape({});
exports.yupBaixaMensal = yup.object({
    acrescimo: yup.number().required().default(0).label('Acréscimo'),
    dataCredito: (0, utils_1.sge2Date)().required().default((0, date_fns_1.format)(Date.now(), 'yyyy/MM/dd')).label('Data crédito'),
    dataRecebimento: (0, utils_1.sge2Date)().required().default((0, date_fns_1.format)(Date.now(), 'yyyy/MM/dd')).label('Data do recebimento'),
    dataVencimento: (0, utils_1.sge2Date)().required().default((0, date_fns_1.format)(Date.now(), 'yyyy/MM/dd')).label('Data Venc.'),
    formaPgto: yup.mixed().oneOf((0, enums_1.enumValues)(enums_1.EFormaPgto)).nullable().default(null).label('Forma de pagamento'),
    idContaBaixa: yup.number().nullable().default(null).label('Conta da baixa'),
    jurosR: yup.number().min(0).default(0).nullable().label('juros r.'),
    multas: yup.number().min(0).default(0).nullable().label('Multas'),
    observacao: yup.string().max(200).nullable().default('').label('Observação'),
    tarifa: yup.number().nullable().default(null).label('Tarifa Bancária'),
    valor: yup.number().positive().min(0).required().default(0).label('Valor Parcela'),
    valorCredito: yup.number().nullable().default(null).label('Valor crédito'),
    valorDesconto: yup.number().default(null).nullable().label('Valor do desconto'),
    valorRecebido: yup.number().required().min(0.1).default(1).nullable().label('Valor recebido'),
});
exports.schemaBaixaMensal = exports.yupBaixaMensal.shape({});
exports.yupMensal = yup.object({
    idCurso: yup.number().integer().positive().required().label('Curso'),
    idProduto: yup.number().integer().nullable().label('Tipo'),
    idCategoriaAluno: yup.number().nullable().default(null).label('Categoria'),
    idGrupo: yup.number().nullable().default(null).label('Grupo'),
    idClasseAluno: yup.number().nullable().default(null).label('Classe'),
    idContaBaixa: yup.number().nullable().default(null).label('Conta da baixa'),
    idContaRegistro: yup.number().nullable().default(null).label('Conte de registro'),
    idEmpresa: yup.number().integer().positive().required().label('Empresa'),
    idUsuario: yup.number().nullable().default(null).label('Usuário'),
    idTipoDesconto1: yup
        .number()
        .nullable()
        .default(null)
        .test('match', 'Desconto 1 deve ser diferente do Desconto 2', (v, { parent: { idTipoDesconto2 } }) => v === null || idTipoDesconto2 === null || v !== idTipoDesconto2)
        .test('match', 'Ao escolher o tipo de desconto deve-se informar o valor', (idTipoDesconto1, schema) => {
        if (idTipoDesconto1 == null && (schema.parent.desconto1 || 0) > 0)
            return false;
        if (idTipoDesconto1 != null && (schema.parent.desconto1 || 0) == 0)
            return false;
        return true;
    })
        .label('Tipo'),
    idTipoDesconto2: yup
        .number()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .default(null)
        .test('match', 'Desconto 1 deve ser diferente do Desconto 2', (v, { parent: { idTipoDesconto1 } }) => v === null || idTipoDesconto1 === null || v !== idTipoDesconto1)
        .test('match', 'Ao escolher o tipo de desconto deve-se informar o valor', (idTipoDesconto2, schema) => {
        if (idTipoDesconto2 == null && (schema.parent.desconto2 || 0) > 0)
            return false;
        if (idTipoDesconto2 != null && (schema.parent.desconto2 || 0) == 0)
            return false;
        return true;
    })
        .label('Tipo'),
    idAluno: yup.number().integer().positive().required().label('Aluno'),
    parcela: yup.string().length(2).required().default('01').label('Parcela'),
    desconto: yup
        .number()
        .required()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(0)
        .test('match', 'Desconto 1 e Desconto 2 não pode ultrapassar 100', (_, { parent: { desconto2, desconto1 } }) => desconto2 || desconto1 ? desconto2 + desconto1 < 100 : true)
        .label('Total Desconto'),
    dataVencimento: (0, utils_1.sge2Date)().required().default(new Date().toISOString()).label('Data Venc.'),
    valorCurso: yup.number().min(0).required().default(0).label('Valor Curso'),
    tipo: yup.string().required().max(15).default('MENSALIDADE').label('Tipo Parcela'),
    valor: yup.number().positive().min(0).required().default(0).label('Valor Parcela'),
    acrescimo: yup.number().required().default(0).label('Acréscimo'),
    dataRecebimento: (0, utils_1.sge2Date)().default(null).nullable().label('Data do recebimento'),
    horaRecebimento: yup.string().default(null).nullable().max(6).label('Hora do pagamento'),
    valorRecebido: yup.number().default(0).nullable().label('Valor recebido'),
    valorDesconto: yup.number().default(null).nullable().label('Valor do desconto'),
    reg: yup
        .number()
        .integer()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(0)
        .nullable()
        .label('Reg'),
    bloqueto: yup.string().max(12).nullable().default('').label('Bloqueto'),
    observacao: yup.string().max(200).nullable().default('').label('Observação'),
    debitoAuto: yup.bool().nullable().default(false).label('Débito automático'),
    cobranca: yup.bool().nullable().default(false).label('Imprimir Cobrança'),
    remessa: yup.bool().nullable().default(false).label('Remessa'),
    naoEnviar: yup.bool().nullable().default(false).label('Enviar ao banco'),
    cobradora: yup.bool().nullable().default(false).label('Cobradora'),
    nCobrador: yup
        .mixed()
        .oneOf(Object.values(enums_1.ENumeroCobradora))
        .nullable()
        .default(enums_1.ENumeroCobradora.Escola)
        .label('Local de Cobrança'),
    prorrogada: yup.bool().nullable().default(false).label('Parcela prorrogada'),
    autMulta: yup.bool().nullable().default(false).label('Sem Multa e Juros'),
    tarifa: yup.number().nullable().default(null).label('Tarifa Bancária'),
    valorCredito: yup.number().nullable().default(null).label('Valor crédito'),
    dataCredito: (0, utils_1.sge2Date)().nullable().default(null).label('Data crédito'),
    data: (0, utils_1.sge2Date)().nullable().default(new Date().toISOString()).label('Data'),
    cobrancaEnviada: yup.bool().nullable().default(false).label('Cob. Env.'),
    dataRemessa: (0, utils_1.sge2Date)().nullable().default(null).label('Data de envio da remessa'),
    carneImpressao: yup.string().nullable().default('').max(6).label('Carne'),
    dataImpressao: (0, utils_1.sge2Date)().nullable().default(null).label('Data de impressão'),
    agrupamento: yup
        .mixed()
        .oneOf((0, enums_1.enumValues)(enums_1.EMensalAgrupamento))
        .required()
        .default(enums_1.EMensalAgrupamento['Padrão'])
        .label('Agrupamento'),
    cdGrat: yup.string().nullable().default('').max(3).label('Cd. Grat.'),
    finan: yup.bool().nullable().default(false).label('Finan.'),
    bolsa: yup.bool().nullable().default(false).label('Bolsa'),
    cartorio: yup.bool().nullable().default(false).label('Está no cartório'),
    dataRegistro: (0, utils_1.sge2Date)().nullable().default(null).label('Data de registro'),
    numeroBanco: yup.string().nullable().default('').max(20).label('Numero do banco'),
    jurosR: yup.number().min(0).default(0).nullable().label('juros r.'),
    multas: yup.number().min(0).default(0).nullable().label('Multas'),
    desconto1: yup
        .number()
        .min(0)
        .max(100)
        .nullable()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .test('match', 'Ao informar o valor do desconto deve-se escolher o tipo', (desconto1, schema) => {
        if (schema.parent.idTipoDesconto1 == null && (desconto1 || 0) > 0)
            return false;
        if (schema.parent.idTipoDesconto1 != null && (desconto1 || 0) == 0)
            return false;
        return true;
    })
        .label('Desconto'),
    desconto2: yup
        .number()
        .min(0)
        .max(100)
        .nullable()
        .transform((cv) => (isNaN(cv) ? null : cv))
        .default(null)
        .test('match', 'Ao informar o valor do desconto deve-se escolher o tipo', (desconto2, schema) => {
        if (schema.parent.idTipoDesconto2 == null && (desconto2 || 0) > 0)
            return false;
        if (schema.parent.idTipoDesconto2 != null && (desconto2 || 0) == 0)
            return false;
        return true;
    })
        .label('Desconto'),
    nPerdeDesc1: yup.bool().nullable().default(false).label('Não Perde desconto'),
    nPerdeDesc2: yup.bool().nullable().default(false).label('Não Perde desconto'),
    loteBaixa: yup.number().integer().min(0).default(0).nullable().label('Lote baixa'),
    loteOrigem: yup.number().integer().min(0).default(0).nullable().label('Lote de origem'),
    linhaDigitavel: yup.string().nullable().default('').max(100).label('Linha digitável'),
    permuta: yup.bool().nullable().default(false).label('Permuta'),
    formaPgto: yup.mixed().oneOf((0, enums_1.enumValues)(enums_1.EFormaPgto)).nullable().default(null).label('Forma de pagamento'),
    descontoBoleto: yup.number().integer().min(0).max(100).nullable().default(0).label('Desconto'),
    nParCartao: yup
        .number()
        .integer()
        .min(0)
        .max(12)
        .transform((cv) => (isNaN(cv) ? null : cv))
        .nullable()
        .default(null)
        .label('Nº Parcelas'),
    emvQrCode: yup.string().nullable().default('').max(500).label('Url QrCode Pix'),
});
exports.schemaMensal = exports.yupMensal.shape({});
